const actions = {
  uploads: async (context, { mapeamento, planilha, unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/manutencao-planilha`, {
      adicional: {
        vendor_id: unidade,
      },
      mapeamento,
      planilha,
    });

    return response;
  },
  listarGrupos: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  listarProdutos: async (
    context,
    { unidade, per_page, page, search, group_id, contract_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/contracts/${contract_id}/products`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        group_id,
        search,
        contract_id,
      },
    });

    return response;
  },

  listarCentros: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/cost-centers`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,

        search,
      },
    });

    return response;
  },

  centroCustoRegras: async (
    context,
    { unidade, per_page, page, search, id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups/${id}/cost-centers`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  editarCustoRegras: async (
    context,
    {
      unidade,
      id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      cost_center_id,
      critico,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/product-groups/${id}/cost-centers`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id: id,
      cost_center_id,
      critico,
    });

    return response;
  },

  deletarCentroCustoRegras: async (context, { id, center_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/product-groups/${id}/cost-centers/${center_id}`
    );

    return response;
  },

  listarFuncao: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/functions`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,

        search,
      },
    });

    return response;
  },

  listarPessoas: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/auth/users`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  listarProdutosSelecionados: async (
    context,
    { unidade, per_page, page, search, id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    if (!id) {
      return;
    }
    const response = await api.get(`/contracts/1/products`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
        group_id: id,
      },
    });

    return response;
  },
  criarGrupo: async (context, { unidade, description, name }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/product-groups`, {
      description,
      name,
      vendor_id: unidade,
    });

    return response;
  },
  adicionarImagem: async (context, { image, product_group_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`/product-groups/image`, {
      image,
      product_group_id,
    });

    return response;
  },
  removerImagem: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/product-groups/image/${id}`);

    return response;
  },
  editarGrupo: async (context, { id, name, description }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${id}`, {
      group_id: id,
      name,
      description,
    });

    return response;
  },
  removerLinha: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/product-groups/${id}`);

    return response;
  },
  removerProdutoGrupo: async (context, { products, contract_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`/contracts/${contract_id}/products`, {
      products,
    });

    return response;
  },
  adicionarProdutoGrupo: async (context, { products, contract_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/contracts/${contract_id}/products`, {
      catalog_id: contract_id,
      products,
    });

    return response;
  },
  adicionarRegraGrupo: async (
    context,
    {
      group_id,
      unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      critico,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/vendors`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      critico,
    });

    return response;
  },
  adicionarRegraCentro: async (
    context,
    {
      group_id,
      unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      critico,
      cost_center_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/cost-centers`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      critico,
      cost_center_id,
    });

    return response;
  },

  adicionarRegraFuncao: async (
    context,
    {
      group_id,

      maximum_days,
      minimum_days,
      control_types,
      amount,
      critico,
      function_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/functions`, {
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      critico,
      function_id,
    });

    return response;
  },

  funcaoRegras: async (context, { unidade, per_page, page, search, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups/${id}/functions`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  unidadeRegras: async (context, { unidade, per_page, page, search, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/product-groups/${id}/vendors`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },

  editarFuncaoRegras: async (
    context,
    {
      unidade,
      id,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      function_id,
      critico,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.put(`/product-groups/${id}/functions`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id: id,
      function_id,
      critico,
    });

    return response;
  },

  editarUnidadeRegras: async (
    context,
    {
      unidade,
      id,
      maximum_days,
      minimum_days,
      control_types,
      amount,

      critico,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${id}/vendors`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id: id,

      critico,
    });

    return response;
  },

  deletarFuncaoRegras: async (context, { id, funcao_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/product-groups/${id}/functions/${funcao_id}`
    );

    return response;
  },

  adicionarRegraPessoa: async (
    context,
    {
      group_id,
      unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      critico,
      user_id,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`/product-groups/${group_id}/users`, {
      vendor_id: unidade,
      maximum_days,
      minimum_days,
      control_types,
      amount,
      group_id,
      critico,
      user_id,
    });

    return response;
  },

  pessoaRegras: async (context, { unidade, search, id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/vendors/${unidade}/regras-de-troca-por-unidade`,
      {
        params: {
          search,
          product_group_id: id,
        },
      }
    );

    return response;
  },

  deletarPessoaRegras: async (context, { id, pessoas_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/product-groups/${id}/users/${pessoas_id}`
    );

    return response;
  },

  deletarUnidadeRegras: async (context, { id, funcao_id }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.delete(
      `/product-groups/${id}/vendors/${funcao_id}`
    );

    return response;
  },

  listarRegras: async (context, { unidade, search }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/vendors/${unidade}/regras-de-troca-por-unidade`,
      {
        params: {
          search,
        },
      }
    );

    return response;
  },

  exportarListarRegras: async (context, { unidade, search, download }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(
      `/vendors/${unidade}/regras-de-troca-por-unidade`,
      {
        params: {
          download,
          search,
        },
      }
    );

    return response;
  },

  sincronizarFuncao: async (context, { unidade }) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.post(`/regra/reindexar-usuarios`, {
      vendorId: unidade,
    });

    return response;
  },
};

export const grupoProdutos = {
  namespaced: true,
  actions,
};
